// extracted by mini-css-extract-plugin
export default {"header":"MvQDX1_9LKZShgbzXu2Z","placeHolderShimmer":"o015NORQIFyXTQ8kzBrA"};